<!-- @Author: xiaodongyu -->
<!-- @Date: 2024-02-24 12:34:15 -->
<!-- @Last Modified by: xiaodongyu -->
<!-- @Last Modified time: 2024-02-29 14:56:56 -->

<template>
    <register-layout :step="3">
        <template #default>
            <div class="register-step3">
                <h2>会員登録申し込み完了</h2>
                <h5 class="bold">
                    お申込み内容を確認後、認証コードをご登録住所宛て郵送いたしますので、しばらくお待ちください。
                </h5>
                <p class="b2">
                    🙏 引き続き、インスタキャッシュをよろしくお願いします。
                </p>
                <p class="b2">
                    <span class="emoji-warn">⚠️ </span>審査の結果、ご登録をいたしかねる場合がございますので、ご了承ください。
                </p>

                <button
                    class="b2 bold"
                    @click="nextStep"
                >
                    トップに戻る
                </button>
            </div>
        </template>
    </register-layout>
</template>

<script>
import RegisterLayout from '../component/register-layout';

export default {
    name: 'RegsiterStep3',

    components: {
        RegisterLayout
    },

    mounted() {
        this.$store.commit('finance/updateFinance', {
            currentStepRouteName: 'RegisterStep3'
        });
    },

    methods: {
        nextStep() {
            this.$router.push({name: 'RegisterKycCode'});
        }
    }
};
</script>

<style lang="scss" scoped>
.register-step3 {
    width: 6.5rem;

    h2 {
        color: $c-01;
    }

    h5 {
        margin: 0.24rem 0;
        color: $c-01;
    }

    p.b2 {
        margin-top: 0.04rem;
        color: $c-02;

        .emoji-warn {
            color: $red-02;
        }
    }

    button {
        display: block;
        margin-top: 0.6rem;
    }
}
</style>
